<span class="label-chip"
      [class.pill]="size === 'pill'"
      [class.inactive]="inactive"
      [style.background]="inactive ? null : styles.background"
      [style.color]="inactive ? null : styles.text">
  <span class="label-chip-name"
        #nameEl
        #nameTooltip="matTooltip"
        [matTooltip]="overflowTooltip ? tooltipText : ''"
        matTooltipPosition="above"
        (mouseenter)="syncTooltip(nameEl, nameTooltip)">{{ labelValue?.name }}<ng-container *ngIf="inactive"> · Inactive</ng-container></span>
  <button *ngIf="removable" type="button" class="label-chip-remove" aria-label="Remove label" (click)="remove($event)">
    <mat-icon>close</mat-icon>
  </button>
</span>
